module.exports = __webpack_public_path__ + "img/www.bestbuy.com.d8d96987.png";